module.exports = "images/placeholder.png";